import React, {createContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

/*
New onboarding questions can be added to this array in the order they should appear.
You can include an additional property like a bucketId that can be used to filter out the question for use cases like A/B tests.
*/
const allOnboardingQuestions = [
  {
    slug: 'welcome',
  },
  {
    slug: 'stores',
  },
  {
    slug: 'guest-count',
    filter: {
      hasGuestCount: true,
    },
  },
  {
    slug: 'interests',
  },
  {
    slug: 'goals',
  },
];

// If you include a filters object, only the questions that do not have the filter key at all OR have the key and a matching value will be returned.
const getApplicableOnboardingQuestions = (filters = {}) => {
  const filterPairs = Object.entries(filters);

  if (filterPairs.length) {
    return allOnboardingQuestions.filter(questionsConfig => {
      return filterPairs.every(([filterKey, filterValue]) => {
        if (
          typeof filterValue !== 'object' ||
          (filterValue.include === undefined &&
            filterValue.exclude === undefined)
        ) {
          throw new Error(
            'Each filter value should be an object with an include or an exclude object',
          );
        }

        if (questionsConfig.filter) {
          if (filterValue.include !== undefined)
            return questionsConfig.filter[filterKey] === filterValue.include;

          if (filterValue.exclude !== undefined)
            return questionsConfig.filter[filterKey] !== filterValue.exclude;
        }

        return true;
      });
    });
  }

  const onboardingQuestions = allOnboardingQuestions.filter(
    question => !Object.prototype.hasOwnProperty.call(question, 'bucketId'),
  );

  return onboardingQuestions;
};

const Context = createContext({
  onboardingQuestions: [],
  determineOnboardingQuestions: noop,
});

export default Context;

export const QuestionsContextProvider = ({children}) => {
  const [questionFilters, setQuestionFilters] = useState({});
  const [onboardingQuestions, setOnboardingQuestions] = useState([]);

  useEffect(() => {
    setOnboardingQuestions(getApplicableOnboardingQuestions(questionFilters));
  }, [questionFilters]);

  return (
    <Context.Provider
      value={{
        onboardingQuestions,
        setQuestionFilters,
      }}>
      {children}
    </Context.Provider>
  );
};

QuestionsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
